export default __webpack_public_path__ + "static/media/bov-zoomed.6866de28.svg";